import { createFileRoute } from '@tanstack/react-router';
import EmployeesCreateModule from '@/modules/employees/employees/EmployeesCreateModule';

export const Route = createFileRoute('/(dashboard)/_dashboard/master-data/employee-add')({
  component: EmployeesCreateModule,
});
